import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbCollapsed, BreadcrumbIcons } from '../../models/types/breadcrumb-icon.enum';
import { IconComponent } from '../icons/icons.component';
import { AssetsCategory } from '../../models/types/assets-category.enum';
import { BreadcrumbItem } from '../../models/types/breadcrumb.type';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { BreadcrumbService } from '../../services/breadcrumb.service';

@Component({
  selector: 'lib-breadcrumbs',
  standalone: true,
  imports: [CommonModule, IconComponent, RouterModule],
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css'],
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  breadcrumbs: BreadcrumbItem[] = [];
  start: BreadcrumbItem[] = [];
  collapsed: BreadcrumbItem[] = [];
  end: BreadcrumbItem[] = [];
  readonly COLLAPSE_AFTER: BreadcrumbCollapsed = BreadcrumbCollapsed.CollapseAfterThree;
  BreadcrumIcon = BreadcrumbIcons;
  AssetsCategory = AssetsCategory;
  Header: string | undefined = '';
  subTitle = '';
  isSubTitle = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
  ) {}

  ngOnInit(): void {
    this.setupBreadcrumbSubscription();
    this.initializeBreadcrumbs();
    this.setupManualRefreshSubscription();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private setupBreadcrumbSubscription(): void {
    const routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this.createBreadcrumbs(this.route.root);
        this.splitBreadcrumbs();
      });
    this.subscriptions.push(routerSub);
  }

  private setupManualRefreshSubscription(): void {
    const refreshSub = this.breadcrumbService.refresh$.subscribe(() => {
      this.refreshBreadcrumbs();
    });
    this.subscriptions.push(refreshSub);
  }

  private initializeBreadcrumbs(): void {
    // Initial load breadcrumbs
    this.breadcrumbs = this.createBreadcrumbs(this.route.root);
    this.splitBreadcrumbs();
  }

  private createBreadcrumbs(
    route: ActivatedRoute,
    url = '',
    breadcrumbs: BreadcrumbItem[] = [],
  ): BreadcrumbItem[] {
    const routeConfig = route.routeConfig;

if (routeConfig?.data?.['breadcrumb']) {

  if (
    routeConfig.path === 'offer/:invitationCode' ||
    routeConfig.path === 'offer-details/:invitationCode'
  ) {
    breadcrumbs.push({
      label: 'Application Selection',
      url: '/student/applications-selection',
    });
  }

  const routeUrl = route.snapshot.url.map(segment => segment.path).join('/');
  url += `/${routeUrl}`;

  const breadcrumbItem: BreadcrumbItem = {
    label: routeConfig.data['breadcrumb'],
    url: url,
  };

  breadcrumbs.push(breadcrumbItem);
}
    if (routeConfig?.data?.['subtitle']) {
      this.isSubTitle = true;
      this.subTitle = routeConfig.data['subtitle'];
    } else {
      if (routeConfig === null) {
        this.isSubTitle = false;
        this.subTitle = '';
      }
    }
    if (route.firstChild) {
      return this.createBreadcrumbs(route.firstChild, url, breadcrumbs);
    }

    // Set header to last breadcrumb label
    if (breadcrumbs.length > 0) {
      this.Header = breadcrumbs[breadcrumbs.length - 1].label;
    }

    return breadcrumbs;
  }

  private splitBreadcrumbs(): void {
    const items = [...this.breadcrumbs];

    if (items.length <= this.COLLAPSE_AFTER) {
      this.start = [...items];
      this.collapsed = [];
      this.end = [];
    } else {
      this.start = [items[0]];
      this.collapsed = items.slice(1, -1);
      this.end = [items[items.length - 1]];
    }
  }

  // Public method to manually refresh breadcrumbs
  public refreshBreadcrumbs(): void {
    this.breadcrumbs = this.createBreadcrumbs(this.route.root);
    this.splitBreadcrumbs();
  }
}
